enum EnergyConsumptionCalculationBasis {
  ENERGY_COUNTER = 'energy_counter',
  POWER = 'power'
}

export default EnergyConsumptionCalculationBasis
